module.exports = __webpack_public_path__ + "static/media/success.1f8e83ed.svg";